/* GASSISA
=========================================================================================
* Descripcion: Version portatil del formulario de accesos.
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revision   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 26/06/2026 | Lic. Jose Luis Aragon Cervantes  | Creacion de version portatil responsiva
* ---------------------------------------------------------------------------------------
*/

import FrmAccesos from "../../../catalogos/accesos/FrmAccesos.jsx";
import SizeSoftXFrmPortatil from "../../leyout/SizeSoftXFrmPortatil.jsx";

export default function FrmAccesosPortatil() {
  return (
    <SizeSoftXFrmPortatil nombreFormulario="FrmAccesos">
      <FrmAccesos />
    </SizeSoftXFrmPortatil>
  );
}
